import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';

@Pipe({
  standalone: false,
    name: 'safeUrl'
})
export class SafeUrlPipe implements PipeTransform {

    constructor(private sanitizer: DomSanitizer) {}

    transform(value: any): any {
        //return this.sanitizer.bypassSecurityTrustStyle(value);
        return this.sanitizer.bypassSecurityTrustResourceUrl(value);
        // return this.sanitizer.bypassSecurityTrustXxx(style); - see docs
    }

}
